// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sOoB","content":"styles_content__2KVsr"};